
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import Template from "@/template.vue";

	import SetTg from './resend-phone'
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			SetTg
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		childDept = [];
		activeNames=[];
		customerUserVisible = false
		showbmxxVisible: boolean = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false
		setSizeVisible=false
		showInfoVisible2=false
		types=[]
		form={
			phone:'',
			xm:'',
			sphone:''
		}
		startTime=[]
		endTime=[]
		childdeptdisable=false
		deptdisable =false
		amount=['','']
		contractList=[]
		bmxx=[]
		loading: boolean = false;
		dataListSelections=[];
		sjbm=[]
		depts=[]
		selectBm=''
		created() {
			this.getDepts()
			this.getUserList()
		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.getUserList();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.getUserList();
		}


		setSize(row){

			this.setSizeVisible = true
			var data = {workerPhone: row.workerPhone,workerSphone:row.workerSphone}

			this.$nextTick(() => {
				this.$refs.setSize.init(data)
			})
		}

		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
			})
		}
		showUser(user) {
			this.$router.push({
				path: "/bjba/grzx",
				query: { username: user.username },
			});
		}

		getAge(strBirthday) {
			var birArr = strBirthday.split("-");
			var birYear = birArr[0];
			var birMonth = birArr[1];
			var birDay = birArr[2];

			d = new Date();
			var nowYear = d.getFullYear();
			var nowMonth = d.getMonth() + 1; //记得加1
			var nowDay = d.getDate();
			var returnAge;

			if (birArr == null) {
				return false
			};
			var d = new Date(birYear, birMonth - 1, birDay);
			if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
				if (nowYear == birYear) {
					returnAge = 0; //
				} else {
					var ageDiff = nowYear - birYear; //
					if (ageDiff > 0) {
						if (nowMonth == birMonth) {
							var dayDiff = nowDay - birDay; //
							if (dayDiff < 0) {
								returnAge = ageDiff - 1;
							} else {
								returnAge = ageDiff;
							}
						} else {
							var monthDiff = nowMonth - birMonth; //
							if (monthDiff < 0) {
								returnAge = ageDiff - 1;
							} else {
								returnAge = ageDiff;
							}
						}
					} else {
						return  "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
					}
				}
				return returnAge;
			} else {
				return ("输入的日期格式错误！");
			}
		}

		selectChanged3(value) {
			this.getUserList();
		}
		changeIndex() {
			this.currentNo = 1;
		}
		getUserList () {
			this.loading = true
			this.form.page = this.currentNo;
			this.form.pagesize = 10
			this.form.userid = this.$store.getters.username
			if(this.startTime &&this.startTime.length==2){
				this.form.txTimest = this.startTime[0]
				this.form.txTimeed = this.startTime[1]
			} else{
				this.form.txTimest = ''
				this.form.txTimeed = ''
			}
			this.$request.get('/bjba/yhgl/findNouseWorkPhone', {
				params: this.form
			}).then(res => {
				const {
					data
				} = res
				console.log("列表数据：", data)
				this.contractList = data.data.content
				this.pageTotal = data.data.totalElements
				this.loading = false
			}).catch(err => {
				this.$message({
					message: '获取用户列表出现异常!',
					type: 'error',
					center: true,
					showClose: true
				})
				this.loading = false
				console.log(err)
			})
		}
	}
